import {
  TOGGLE_TUTORIAL,
  TOGGLE_TUTORIAL_START_DIALOG,
  SET_CURRENT_TUTORIAL_STEP,
  TOGGLE_TUTORIAL_CONFIRMATION_DIALOG,
} from '../lib/types';

export const toggleTutorialAction = (toggle) => (dispatch) => {
  dispatch({
    type: TOGGLE_TUTORIAL,
    payload: toggle,
  });
};

export const toggleTutorialStartDialog = (value) => (dispatch) => {
  dispatch({
    type: TOGGLE_TUTORIAL_START_DIALOG,
    payload: value,
  });
};

export const toggleConfirmationDialog = (value) => (dispatch) => {
  dispatch({
    type: TOGGLE_TUTORIAL_CONFIRMATION_DIALOG,
    payload: value,
  });
};

export const setCurrentTutorialStep = (value) => (dispatch) => {
  dispatch({
    type: SET_CURRENT_TUTORIAL_STEP,
    payload: value,
  });
};



// WEBPACK FOOTER //
// ./src/actions/tutorial-actions.js